import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BillingManagementService } from 'src/service/billing-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { BilledProduct, BillingStatus, GeneralConfigType, InteractionType, KeyValueSet, LastUsedKey, LastUsedSettingsType, LiveTokenWrapper, LocalService, PageKey } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';
import { WsUserService } from 'src/service/ws/ws-user.service';
import { EmitResponse } from 'src/service/ws/wsSupporting/wsEntities';
import { EmitType, RegisterName } from 'src/service/ws/wsSupporting/wsTypes';

@Component({
  selector: 'app-live-tokens',
  templateUrl: './live-tokens.component.html',
  styleUrls: ['./live-tokens.component.scss']
})
export class LiveTokensComponent implements OnInit {
  ctryCode: string = ''; userId: string = ''; interactionType: InteractionType; businessId: string = '';
  lstSectionConfigKeys: string[] = ["live_tokens"]; billingStatuses: KeyValueSet[];
  selectedStatuses: string[] = [BillingStatus.AmountPaid.toString()];
  moreStatuses: KeyValueSet[]; selectedBilligStatus: string = BillingStatus.Delivered.toString();
  selectedBilligStatusText: string = ''; isShowMoreStatus: boolean = false;
  isShowOnlyOwnLoginAssigned = false; wrapper: LiveTokenWrapper | null;
  maxBodyHeight = 0; isBillSelectionDisabled = false; isBillProductSelectionDisabled = false; selectedBill: string[] = [];
  isSelectAll = false; isShowSettings = false;

  private audio = new Audio();

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private billingManagementService: BillingManagementService, private cdr: ChangeDetectorRef, private profileManagementService: ProfileManagementService, private wsUserService: WsUserService) {
    this.audio.src = 'assets/sounds/dragon-studio-alert-444816.mp3';
    this.audio.load();
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.businessId = routeParams.businessId;
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.configurationManagementService.ensurePageActions(PageKey.LiveTokens, this.businessId);
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.onInitiate();
      }
    });
  }

  playAlert() {
    this.audio.play().catch(error => {
      console.log('Playback failed:', error);
    });
  }

  ngAfterViewInit() {
    this.onCheckWsBusinesEmitDetection();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onGetLastUsedSettings();
    if (this.localService.billingStatus) {
      this.onSetStatuses();
    } else {
      this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.BillingStatus, true, false).subscribe(result => {
        this.localService.billingStatus = result;
        this.onSetStatuses();
      });
    }
  }

  onLoad() {
    const statues = this.selectedStatuses.map(x => parseInt(x)).filter(x => x);
    this.billingManagementService.getLiveTokens(this.businessId, this.isShowOnlyOwnLoginAssigned, statues, this.selectedBilligStatus, this.wrapper ? this.wrapper.tokens.paging : null).subscribe(result => {
      this.onSetSelectAfterLoad(result);
    });
  }

  onGetRemainingQty(qty: string, deliveredQty): string {
    return (parseFloat(qty) - parseFloat(deliveredQty)).toString();
  }

  onSetSelectAfterLoad(result: LiveTokenWrapper) {

    if (this.selectedBill.length > 0) {
      let selectedKeys: string[] = [];

      if (!this.isBillSelectionDisabled) {
        result.tokens.items.forEach(item => {
          if (this.selectedBill.includes(item.key)) {
            selectedKeys.push(item.key);
            item.isSelected = true;
          }
        });
      }

      if (!this.isBillProductSelectionDisabled) {
        result.billedProducts.forEach(billedProduct => {
          billedProduct.products.forEach(item => {
            if (this.selectedBill.includes(item.details.key)) {
              selectedKeys.push(item.details.key);
              item.details.isSelected = true;
            }
          })
        });
      }

      this.selectedBill = selectedKeys;
    }

    if (this.selectedBill.length == 0) {
      this.isBillSelectionDisabled = false;
      this.isBillProductSelectionDisabled = false;
    }
    this.wrapper = result;
    this.isSelectAll = this.wrapper.tokens.items.length > 0 && this.wrapper.tokens.items.length == this.wrapper.tokens.items.filter(x => x.isSelected).length;
  }

  onInitiateMoreStatuses() {
    this.moreStatuses = [];
    const statues: BillingStatus[] = [BillingStatus.Accepted, BillingStatus.OutForDeliver, BillingStatus.Ready, BillingStatus.Delivered];

    statues.forEach(status => {
      var item = this.localService.billingStatus.find(x => x.key == status.toString());
      if (item) {
        this.moreStatuses.push({
          key: item.key,
          value: item.value
        } as KeyValueSet);
      }
    });
  }

  onGetSelectedItems() {
    this.selectedBill = [];
    if (this.wrapper) {
      if (!this.isBillSelectionDisabled) {
        this.selectedBill = this.wrapper.tokens.items.filter(x => x.isSelected).map(x => x.key);
      }
      if (!this.isBillProductSelectionDisabled) {
        this.wrapper.billedProducts.forEach(billedProduct => {
          const selectedKeys = billedProduct.products.filter(x => x.details.isSelected).map(x => x.details.key);
          if (selectedKeys.length > 0) {
            this.selectedBill.push(...selectedKeys);
          }
        });
      }
    }
  }

  onSetStatuses() {
    if (this.localService.billingStatus) {
      this.onInitiateMoreStatuses();
      this.selectedBilligStatusText = this.localService.billingStatus.find(x => x.key == this.selectedBilligStatus)?.value;

      const statues: BillingStatus[] = [BillingStatus.Accepted, BillingStatus.OutForDeliver, BillingStatus.AmountPaid, BillingStatus.Ready, BillingStatus.Submitted];
      let billingStatusesTemp: KeyValueSet[] = [];
      statues.forEach(status => {
        var item = this.localService.billingStatus.find(x => x.key == status.toString());
        if (item) {
          billingStatusesTemp.push({
            key: item.key,
            value: item.value
          } as KeyValueSet);
        }
      });
      this.billingStatuses = billingStatusesTemp;
      this.onLoad();
    }
  }

  onCheckWsBusinesEmitDetection() {
    this.wsUserService.onEmitDetected(RegisterName.BusinessEmitDetected).subscribe((res: EmitResponse) => {
      const statusUpdatedBy = res.result.statusUpdatedBy;
      if (statusUpdatedBy != this.userId) {
        switch (res.emitType) {
          case EmitType.BillingAmountPaid:
          case EmitType.BillingStatusUpdated:
          case EmitType.RefreshLiveTokens: {
            this.playAlert();
            this.onLoad();
          } break;
        }
      }
    });
  }

  onAction(index, key = '', key2 = '') {
    switch (index) {
      case 1: {
        if (!this.isBillSelectionDisabled) {
          this.billingManagementService.updateBillingStatusBulk(this.selectedBill, parseInt(this.selectedBilligStatus), this.businessId).subscribe(result => {
            this.onLoad();
          });
        }
        if (!this.isBillProductSelectionDisabled) {
          this.billingManagementService.markProductStatus(this.selectedBill, parseInt(this.selectedBilligStatus), this.businessId).subscribe(result => {
            this.onLoad();
          });
        }
      } break;
      case 2: {
        let item = this.wrapper.tokens.items.find(x => x.key == key);
        if (item)
          item.isReadonly = !item.isReadonly;
      } break;
      case 3: {
        this.onSaveLastUsedSettings();
        this.onLoad();
      } break;
      case 4: {
        this.isShowMoreStatus = !this.isShowMoreStatus;
      } break;
      case 5: {
        if (!(key.indexOf('more_status') > -1)) {
          this.isShowMoreStatus = false;
        }
      } break;
      case 6: {
        const selectedItem = this.moreStatuses.find(x => x.isSelected);
        if (selectedItem) {
          this.selectedBilligStatus = selectedItem.key;
          this.selectedBilligStatusText = this.localService.billingStatus.find(x => x.key == this.selectedBilligStatus)?.value;
          this.isShowMoreStatus = false;
          this.onSaveLastUsedSettings();
          this.onLoad();
        }
      } break;
      case 7: {
        this.onItemSelectChange(key2, key);
      } break;
      case 8: {
        this.wrapper.tokens.items.forEach(x => {
          x.isSelected = this.isSelectAll
        });
        this.onAfterItemChange();
      } break;
      case 9: {
        this.isShowSettings = !this.isShowSettings;
      } break;
    }
  }

  onItemSelectChange(billingId: string, billingDetailId: string) {
    if (!this.isBillProductSelectionDisabled) {
      let item = this.wrapper.billedProducts.find(x => x.billingId == billingId);
      if (item) {
        let itemSub = item.products.find(x => x.details.key == billingDetailId);
        if (itemSub) {
          itemSub.details.isSelected = !itemSub.details.isSelected;
        }
      }
    }

    this.onAfterItemChange();
  }

  onAfterItemChange() {
    this.isSelectAll = this.wrapper.tokens.items.length > 0 && this.wrapper.tokens.items.length == this.wrapper.tokens.items.filter(x => x.isSelected).length;

    this.isBillSelectionDisabled = false;
    this.isBillProductSelectionDisabled = false;

    if (this.wrapper.tokens.items.filter(x => x.isSelected).length > 0) {
      this.isBillProductSelectionDisabled = true;
    }

    if (this.wrapper.billedProducts.filter(x => x.products.filter(y => y.details.isSelected).length > 0).length > 0) {
      this.isBillSelectionDisabled = true;
    }

    this.onGetSelectedItems();
  }

  onGetTokenProducts(billingId: string): BilledProduct[] {
    const item = this.wrapper.billedProducts.find(x => x.billingId == billingId);
    return item ? item.products : [];
  }

  onSaveLastUsedSettings() {
    var items: LastUsedKey[] = [];
    var temp = this.localService.getLastUsedSetting(LastUsedSettingsType.LiveTokenStatuses);
    if (temp != this.selectedStatuses.join("-"))
      items.push({ keyType: LastUsedSettingsType.LiveTokenStatuses, value: this.selectedStatuses.join("-") } as LastUsedKey);

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.LiveTokensShowOnlyMe);
    const status: string = this.isShowOnlyOwnLoginAssigned ? '1' : '0';
    if (temp != status)
      items.push({ keyType: LastUsedSettingsType.LiveTokensShowOnlyMe, value: status } as LastUsedKey);

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.LiveTokenSelectedStatus);
    if (temp != this.selectedBilligStatus)
      items.push({ keyType: LastUsedSettingsType.LiveTokenSelectedStatus, value: this.selectedBilligStatus } as LastUsedKey);

    if (items.length > 0) {
      this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
      });
    }
  }

  onGetLastUsedSettings() {
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.LiveTokenStatuses);
    if (temp) {
      this.selectedStatuses = temp.split("-");
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.LiveTokensShowOnlyMe);
    if (temp) {
      this.isShowOnlyOwnLoginAssigned = temp == '1';
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.LiveTokenSelectedStatus);
    if (temp) {
      this.selectedBilligStatus = temp;
    }
  }
}
